import I18n from '@i18n';
import styled from '@src/styled-components';
import { Button, Col, DatePicker, Form, Icon, Input } from 'antd';
import pt_BR from 'antd/lib/locale-provider/pt_BR';
import moment from 'moment';
import React from 'react';


const { RangePicker } = DatePicker;
const InputGroup = Input.Group;

type PropsType = {
    defaultValue?: string;
    buttonText: string;
    onSubmit: Function;
    placeholder: string;
    pickerValue?: number[] | undefined;
    dateSubmit?: any;
    isDate?: boolean;
    onDateChange?: Function;
    datesUsed?: number[] | undefined;
    removeFilter?: any;
    canRemoveFilter?: boolean;
};


class SearchComponent extends React.Component<PropsType> {

    onDateChange = async (dates: any[], dateStrings: string[], onDateChangeCallback: any) => {
        try {
            const fromDate = dates[0].toDate();
            const toDate = dates[1].toDate();

            const datesInMilliseconds = [fromDate.getTime(), toDate.getTime()];

            onDateChangeCallback(datesInMilliseconds);
        } catch (error) {
            console.error("Date Error: ", error.message);
        }
    }

    getDefaultValueToDate(datesInMilliseconds: number[] | Date[] | undefined) {
        let momentArray: any = [];

        if (datesInMilliseconds !== undefined) {
            for (let i = 0; i < datesInMilliseconds.length; i++) {
                momentArray.push(moment(new Date(datesInMilliseconds[i]), "YYYY-MM-DD HH:mm:ss"));
            }
        }

        return momentArray;
    }

    render() {
        const { onSubmit, defaultValue, placeholder, buttonText, datesUsed, canRemoveFilter, removeFilter, pickerValue, dateSubmit } = this.props;

        return (
            <div>
                {
                    (!this.props.isDate) &&
                    <SearchContainer className="search-component">
                        <Form layout="inline"

                            onSubmit={(values) => {
                                onSubmit(values);
                            }}
                        >
                            <InputGroup size="large">
                                <Col sm={24} md={18} lg={16} xl={16}>
                                    <Input
                                        suffix={<Icon type="search" />}
                                        placeholder={I18n.l(placeholder)}
                                        defaultValue={defaultValue || ""}
                                        name="find"
                                        id="find"
                                        size="large" />
                                </Col>
                                <Col sm={24} md={6} lg={8} xl={8}>
                                    <Button
                                        htmlType="submit"
                                        size="large"
                                    >
                                        {I18n.l(buttonText)}
                                    </Button>
                                </Col>
                            </InputGroup>

                        </Form>
                    </SearchContainer>
                }
                {
                    (this.props.isDate) &&
                    <DateFilter>
                        <Col sm={24} md={24} xl={24}>
                            <h2>{I18n.l('form.labels.rangePicker')}</h2>
                        </Col>
                        <Col sm={12} md={24} xl={24}>
                            <RangePicker
                                defaultValue={this.getDefaultValueToDate(datesUsed)}
                                size={"large"}
                                value={this.getDefaultValueToDate(pickerValue)}
                                onChange={(e) => this.onDateChange(e, [], this.props.onDateChange)}
                                showTime={true}
                                format={I18n.l('formats.date')}
                                locale={pt_BR.DatePicker}
                                allowClear={false}
                                ranges={{
                                    'Hoje': [moment(), moment()],
                                    'This Month': [moment(), moment().endOf('month')]
                                }}
                            />
                        </Col>
                        <Col sm={24} md={24} xl={24} className="goepik-component-padding">
                            <Button
                                onClick={dateSubmit ? dateSubmit : undefined}
                                type="primary"
                                htmlType="submit"
                                size="large">
                                {I18n.l(buttonText).toUpperCase()}
                            </Button>
                            <Button
                                disabled={!canRemoveFilter}
                                onClick={!!removeFilter ? removeFilter : undefined}
                                type="default"
                                size="large">
                                {I18n.l('common.removeFilter').toUpperCase()}
                            </Button>
                        </Col>
                    </DateFilter>
                }
            </div>
        )
    }
}

const SearchContainer = styled.div`
    max-width:85%;
    Button{
        font-weight: bold;
        text-transform: uppercase;
        margin-left:6px;
        min-width:120px;
        border-color: #1890ff;
        color: #1890ff;
    }
`;

const DateFilter = styled.div`
    .ant-btn {
        margin-right: 10px;
    }

    .ant-calendar-picker {
        width: 400px!important;
    }

    div.ant-calendar-range-quick-selector {
        text-align: left;
        cursor: pointer;
    }
`;

export default SearchComponent;